import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import baseUrl from "../../../../../api/baseUrl";
import TreatmentDrop from "./TreatmentDrop";
import { useDispatch } from "react-redux";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../../../redux/loader/loaderActions";
import CloseIcon from "@mui/icons-material/Close";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
type FormDataType = {
  treatmentkey: number;
  treatment: string;
  treatments: string;
  treatmentId: string;
  type: string;
  types: string;
  typeId: string;
  subtype: string;
  subtypes: string;
  subtypeId: string;
  toothNos: string;
  toothNo: string;
  prices: number;
  price: number;
  description: string;
  createdAt: Date;
  quantity: number;
  note: string;
  surface: string;
  status: string;
  didBy?: string; // Make didBy optional
};
function InvoiceTreatment({
  setaddTreatmentOpent,
  settreatment,
  treatment,
  doctorid,
  addToTreatment,
}: any) {
  const { ID } = useParams();
  const [openOther, setopenOther] = useState(false);
  const [otherserror, setotherserror] = useState(false);
  const [data, setData] = useState([]);

  const initialFormData: FormDataType = {
    treatmentkey: treatment.length + 1,
    treatment: "",
    treatments: "",
    treatmentId: "",
    type: "",
    types: "",
    typeId: "",
    status: "Complete",
    subtype: "",
    subtypes: "",
    subtypeId: "",
    toothNos: "",
    toothNo: "",
    prices: 0,
    price: 0,
    description: "",
    createdAt: new Date(),
    quantity: 1,
    note: "",
    surface: "",
  };

  // Conditionally add didBy field if doctorid is present
  if (!ID) {
    (initialFormData as FormDataType).didBy = doctorid;
  }
  const [formData, setformData] = useState(initialFormData);
  const dispatch = useDispatch();
  useEffect(() => {
    baseUrl
      .get("alltreatment/findAllTreatment")
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const onchange = (e: any) => {
    const { value, name } = e.target;
    if (name === "treatments") {
      if (value === "others") {
        setopenOther(true);
        setformData((prevState) => ({
          ...prevState,
          [name]: value,
          treatment: value,
          treatmentId: value,
          prices: 0,
        }));
      } else {
        setopenOther(false);

        const separatedArray = value.split("/");

        setformData((prevState) => ({
          ...prevState,
          [name]: value,
          treatmentId: separatedArray[0],
          treatment: separatedArray[1],
          prices: separatedArray[separatedArray.length - 1],
        }));
      }
    } else if (name === "types") {
      const separatedArray = value.split("/");
      setformData((prevState) => ({
        ...prevState,
        [name]: value,
        typeId: separatedArray[0],
        type: separatedArray[1],
        prices: separatedArray[separatedArray.length - 1],
      }));
    } else if (name === "subtypes") {
      const separatedArray = value.split("/");
      setformData((prevState) => ({
        ...prevState,
        [name]: value,
        subtypeId: separatedArray[0],
        subtype: separatedArray[1],
        prices: separatedArray[separatedArray.length - 1],
      }));
    } else if (name === "quantity") {
      setformData((prevState) => ({
        ...prevState,
        [name]: value,
        // price: formData.quantity
      }));
    } else {
      setformData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const onsubmit = (e: any) => {
    e.preventDefault();
    if (ID) {
      if (formData.treatments === "others") {
        if (formData.description !== "" && formData.prices > 0) {
          dispatch(setloadeActive());

          baseUrl
            .post(
              "treatment/add-treatments",
              {
                ...formData,
                treatment: formData.description,
                price: formData.prices * formData.quantity,
              },
              {
                headers: {
                  treatmentid: ID,
                },
              }
            )
            .then((response) => {
              dispatch(setloadeDeactive());
              setaddTreatmentOpent(false);
            })
            .catch((error) => {
              dispatch(setloadeDeactive());

              console.log(error);
            });
        } else {
          setotherserror(true);
        }
      } else {
        const price = formData.prices * formData.quantity;
        baseUrl
          .post(
            "treatment/add-treatments",
            { ...formData, price, },
            {
              headers: {
                treatmentid: ID,
              },
            }
          )
          .then((response) => {
            setaddTreatmentOpent(false);
          })
          .catch((error) => {
            console.log(error);
          });
      }
      addToTreatment();
    } else {
      if (formData.treatments === "others") {
        if (formData.description !== "" && formData.prices > 0) {
          settreatment([
            ...treatment,
            {
              ...formData,
              treatment: formData.description,
              price: formData.prices * formData.quantity,
            },
          ]);
          addToTreatment([
            ...treatment,
            {
              ...formData,
              treatment: formData.description,
              price: formData.prices * formData.quantity,
            },
          ]);

          setaddTreatmentOpent(false);
        } else {
          setotherserror(true);
        }
      } else {
        settreatment([
          ...treatment,
          { ...formData, price: formData.prices * formData.quantity },
        ]);
        addToTreatment([
          ...treatment,
          { ...formData, price: formData.prices * formData.quantity },
        ]);
        setaddTreatmentOpent(false);
      }
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between bg-gradient-to-r from-primary to-primaryLight">
          <div className="flex items-center gap-3">
            <MedicalServicesIcon className="text-white" />
            <h2 className="text-xl font-bold text-white">Add Treatment</h2>
          </div>
          <button
            onClick={() => setaddTreatmentOpent(false)}
            className="w-8 h-8 rounded-lg bg-white/20 hover:bg-white/30 flex items-center justify-center text-white transition-colors"
          >
            <CloseIcon sx={{ fontSize: 20 }} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={onsubmit} className="flex-1 overflow-y-auto p-6 space-y-4">
          <TreatmentDrop
            onChange={onchange}
            label="Select Treatment"
            name="treatments"
            data={data}
          />

          {data
            ?.filter((item: any) => item._id === formData.treatmentId)
            ?.map((filteredItem: any) => filteredItem.type)
            ?.flat().length > 0 && (
            <TreatmentDrop
              label="Select Type"
              onChange={onchange}
              name="types"
              data={data
                ?.filter((item: any) => item._id === formData.treatmentId)
                ?.map((filteredItem: any) => filteredItem.type)
                ?.flat()}
            />
          )}

          {data
            ?.filter((item: any) => item._id === formData.treatmentId)
            .map((filteredItem: any) => filteredItem.type)
            ?.flat()
            ?.filter((item: any) => item._id === formData.typeId)
            .map((filteredItem: any) => filteredItem.subType)
            ?.flat().length > 0 && (
            <TreatmentDrop
              onChange={onchange}
              label="Select Subtype"
              name="subtypes"
              data={data
                ?.filter((item: any) => item._id === formData.treatmentId)
                .map((filteredItem: any) => filteredItem.type)
                ?.flat()
                ?.filter((item: any) => item._id === formData.typeId)
                .map((filteredItem: any) => filteredItem.subType)
                ?.flat()}
            />
          )}

          {/* Price & Quantity Row */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">
                Price <span className="text-red-500">*</span>
              </label>
              <input
                value={formData.prices}
                name="prices"
                type="number"
                onChange={onchange}
                disabled={!openOther}
                className={`w-full px-4 py-2.5 rounded-xl border focus:outline-none transition-all ${
                  openOther
                    ? "border-gray-600 bg-slate-50"
                    : "bg-slate-100 border-gray-600 text-slate-500 cursor-not-allowed"
                }`}
              />
              {otherserror && formData.prices <= 0 && (
                <p className="text-xs text-red-500 mt-1">Price must be greater than 0</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Quantity</label>
              <input
                value={formData.quantity}
                name="quantity"
                type="number"
                onChange={onchange}
                className="w-full px-4 py-2.5 rounded-xl border border-gray-600 focus:outline-none transition-all bg-slate-50"
              />
            </div>
          </div>

          {/* Total Display */}
          <div className="p-3 bg-emerald-50 rounded-xl">
            <p className="text-sm text-emerald-700">
              Total: <span className="font-bold text-lg">Rs {formData.prices * formData.quantity}</span>
            </p>
          </div>

          {/* Others Description */}
          {openOther && (
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">
                Description <span className="text-red-500">*</span>
              </label>
              <input
                value={formData.description}
                name="description"
                type="text"
                onChange={onchange}
                placeholder="Enter treatment description..."
                className="w-full px-4 py-2.5 rounded-xl border border-gray-600 focus:outline-none transition-all bg-slate-50"
              />
              {otherserror && formData.description === "" && (
                <p className="text-xs text-red-500 mt-1">Description is required for custom treatments</p>
              )}
            </div>
          )}

          {/* Tooth No & Surface Row */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Tooth No</label>
              <input
                value={formData.toothNo}
                name="toothNo"
                type="number"
                onChange={onchange}
                placeholder="e.g., 11, 21"
                className="w-full px-4 py-2.5 rounded-xl border border-gray-600 focus:outline-none transition-all bg-slate-50"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Surface</label>
              <input
                value={formData.surface}
                name="surface"
                type="text"
                onChange={onchange}
                placeholder="e.g., M, D, O"
                className="w-full px-4 py-2.5 rounded-xl border border-gray-600 focus:outline-none transition-all bg-slate-50"
              />
            </div>
          </div>

          {/* Note */}
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1.5">Note</label>
            <input
              value={formData.note}
              name="note"
              type="text"
              onChange={onchange}
              placeholder="Additional notes..."
              className="w-full px-4 py-2.5 rounded-xl border border-gray-600 focus:outline-none transition-all bg-slate-50"
            />
          </div>

          {/* Submit Button */}
          <div className="flex gap-3 pt-2">
            <button
              type="button"
              onClick={() => setaddTreatmentOpent(false)}
              className="flex-1 px-4 py-2.5 rounded-xl border border-slate-200 text-slate-600 font-medium hover:bg-slate-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-4 py-2.5 rounded-xl bg-gradient-to-r from-primary to-primaryLight text-white font-medium hover:shadow-lg hover:shadow-primary/20 transition-all"
            >
              Add Treatment
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default InvoiceTreatment;
